var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0.667969C0.6 0.667969 0 1.26797 0 2.0013C0 2.73464 0.6 3.33464 1.33333 3.33464C2.06667 3.33464 2.66667 2.73464 2.66667 2.0013C2.66667 1.26797 2.06667 0.667969 1.33333 0.667969ZM10.6667 0.667969C9.93333 0.667969 9.33333 1.26797 9.33333 2.0013C9.33333 2.73464 9.93333 3.33464 10.6667 3.33464C11.4 3.33464 12 2.73464 12 2.0013C12 1.26797 11.4 0.667969 10.6667 0.667969ZM6 0.667969C5.26667 0.667969 4.66667 1.26797 4.66667 2.0013C4.66667 2.73464 5.26667 3.33464 6 3.33464C6.73333 3.33464 7.33333 2.73464 7.33333 2.0013C7.33333 1.26797 6.73333 0.667969 6 0.667969Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.65d8f612e2dfa7a9b2bce7b2ee889c87.svg";
export { ForwardRef as ReactComponent };